<template>
    <div class="wrapper wrapper-content wrapper-boxed">

        <span class="text-muted small float-right">Showing 1 to {{reviews.length}} of {{totalReviews}} </span>
        <div class="row m-t-xl m-b-md">
            <div class="col-sm-6">
                <h1 class="title">Sprint Reviews</h1>
            </div>
            <div class="col-sm-6 text-right">
                <button type="button" class="btn btn-success btn-outline btn-add-sla" data-toggle="collapse" data-target="#createSprintReview" aria-expanded="false" aria-controls="createSprintReview">
                    <i class="fa fa-plus"></i> New Sprint Review
                </button>
            </div>    
        </div><!-- /.row -->

        <div v-if="$user.isAdmin" class="collapse" id="createSprintReview">
            <div class="ibox ibox-add-user">
                <div class="ibox-title">
                    <h5>New Sprint Review</h5>
                </div>
                <div class="ibox-content">
                    <div class="form-horizontal">
                        <div class="row">
                            <div class="col-md-6 col-lg-4">
                                <div class="form-group">
                                    <label class="control-label col-md-4">Name:</label>
                                    <div class="col-md-8">
                                        <input type="text" placeholder="Sprint 1" class="form-control" v-model="newReview.name" />
                                    </div>
                                </div><!-- /.form-group -->
                            </div>
                            <div class="col-md-6 col-lg-4">
                                <div class="form-group">
                                    <label class="control-label col-md-4">Project:</label>
                                    <div class="col-md-8">
                                        <selectize
                                            v-if="projects.length"
                                            :options="projects"
                                            name="review_project"
                                            class="selectize bordered"
                                            placeholder="Select project"
                                            :searchable="false"
                                            v-model="newReview.project_id"
                                            data-vv-as="">
                                          </selectize>
                                    </div>
                                </div><!-- /.form-group -->
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 col-lg-4">
                                <div class="form-group">
                                    <label class="control-label col-md-4">Review Date:</label>
                                    <div class="col-md-8">
                                        <datepicker v-bind:value="newReview.reviewed_on" @input="selectedDate" input-class="form-control"></datepicker>
                                    </div>
                                </div><!-- /.form-group -->
                            </div>    
                        </div><!-- /.row -->
                        <div class="hr-line-dashed"></div>
                        <div class="row">
                            <div class="col-md-12 col-lg-12">
                                <ladda-button :on-click="createReview" class="btn btn-success float-right"><i class="fa fa-plus"></i> Save</ladda-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="decorative-divider m-b-md"></div>

        <div class="row m-b-md">
            <div class="col-md-8">
                
            </div>
            <div class="col-md-4">
                <div class="input-group">
                    <input v-model="search_string" type="text" placeholder="Search projects " class="input form-control" @keyup.enter="search">
                    <span class="input-group-btn">
                            <button type="button" class="btn btn btn-primary"> <i class="fa fa-search" v-show="!searching"></i> <i class="fa fa-spinner fa-spin" v-show="searching"></i> Search</button>
                    </span>
                </div>
            </div>
        </div><!-- /.row -->

        <div class="clients-list">
            <div class="full-height-scroll">
                <ul class="list-sla">
                    <li v-for="review in reviews" v-bind:key="review.id">
                        <div class="row">
                            <div class="col-12 col-md-8 col-lg-8">
                                <div class="client truncate">
                                    <span class="status status-good"></span>
                                    <router-link tag="p" :to="{ name: 'sprint-reviews.show', params: { 'sprint_review_id': review.id }}">{{ review.project.title }} - {{ review.name }}</router-link>
                                </div>
                                <ul class="details">
                                    <li data-toggle="tooltip" data-placement="top" title="Contract Period"><i class="fa fa-calendar"></i> {{ review.reviewed_on | moment('D MMM YY') }}</li>
                                </ul>
                            </div>
                            <div class="col-12 col-md-4 col-lg-4 text-right">
                                <ladda-button :on-click="deleteReview" :arguments="[review.id]" class="" :type="'danger'"><i class="fa fa-trash"></i></ladda-button>
                            </div>
                            <div class="col-12 col-md-4 col-lg-4 text-right">
                                
                            </div>
                        </div><!-- /.row -->
                    </li>
                </ul><!-- /.sla-usage -->
                <div v-if="reviews.length < totalReviews && reviews.length > 0" class="row">
                    <div class="col-md-12 text-center">
                        <ladda-button :on-click="loadMore" class="btn btn-default">Load More</ladda-button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

    import Review from './../../models/sprint-review.js'
    import Datepicker from 'vuejs-datepicker'
    import { Selectize, LaddaButton } from 'components/form/input'
    
    export default {
        components: {
            Datepicker,
            Selectize,
            LaddaButton
        },

        data: function () {
            return {
                reviews: [],
                projects: [],
                newReview: new Review(),
                current_page: 1,
                last_page: 1,
                totalReviews: 0,
                loading: true,
                search_string: '',
                searching: false,
            }
        },
        mounted: function() {

            var that = this;

        },
        created: function() {
            this.fetchData();
        },
        watch: {
        },
        methods: {
            selectedDate (e) {
                this.newReview.reviewed_on = e
            },

            fetchData: function() {
                var that = this;
                var clientFilter = '';

                Promise.all([
                    client({path: '/sprint-reviews?' + this.getQueryParams() }).then(
                        function(response) {
                            that.loading = false;

                            return response.entity
                        },
                        function(response) {
                            
                        }
                    ),
                    client({path: '/projects/list'}).then(
                        function(response) {
                            that.loading = false;

                            return response.entity
                        },
                        function(response) {
                            
                        }
                    ),
                ]).then(function(data) {
                    
                    that.reviews = data[0].data
                    that.current_page = data[0].current_page
                    that.last_page = data[0].last_page
                    that.totalReviews = data[0].total
                    that.projects = data[1]
                })
            },
            setSorting: function(value) {
                this.sort = value

                this.search()
            },
            deleteReview () {


            },
            getQueryParams: function() {

                return $.param({
                    search: this.search_string,
                    page: this.current_page
                })
            },
            loadMore: function(e) {
                var that = this;
                this.loading = true;

                if (this.current_page >= this.last_page) { return }

                this.current_page = this.current_page + 1

                return client({path: '/sprint-reviews?' + this.getQueryParams() }).then(
                    function(response) {
                        that.reviews.push.apply(that.reviews, response.entity.data)
                        that.last_page = response.entity.last_page
                        that.current_page = response.entity.current_page
                        that.totalReviews = response.entity.total
                        that.loading = false
                    },
                    function(response) {
                        that.loading = false
                    }

                )
            },
            search: function(e) {
                var that = this;

                this.searching = true
                this.current_page = 1

                client({path: '/sprint-reviews?' + this.getQueryParams() }).then(
                    function(response) {
                        that.reviews = response.entity.data
                        that.current_page = response.entity.current_page
                        that.totalReviews = response.entity.total
                        that.searching = false
                    },
                    function(response) {
                        this.searching = false
                    }

                )
            },

            createReview () {
                var that = this
                this.newReview.reviewed_on = moment(this.newReview.reviewed_on).format('YYYY-MM-DD')

                return client({path: '/sprint-reviews', entity: this.newReview, method: 'POST'}).then( 
                    function(response) {
                        that.newReview = new Review()
                        that.reviews.push(response.entity)
                        $('.collapse').collapse('hide');
                    },
                    function(response) {
                        if (response.status.code == 422) {
                            var firstValidationIssue = response.entity[Object.keys(response.entity)[0]];
                            
                        } else {
                            
                        }
                    }
                )
            },

            deleteReview (id) {
                var that = this

                return client({path: '/sprint-reviews/'+id, method: 'DELETE'}).then( 
                    function(response) {
                        that.reviews.splice(that.reviews.findIndex(x => x.id === id), 1);
                    },
                    function(response) {
                    }
                )
            }
        }
    }
</script>

<style scoped>
    
</style>